import React from 'react';
import InterviewPrep from '../Instructions/InterviewPrep';


function Instructions() {
  return <InterviewPrep />;
}


export default Instructions;